export enum ProductPriceRecurrence {
	ONE_TIME = 'ONE_TIME',
	YEAR_SUBSCRIPTION = 'YEAR_SUBSCRIPTION',
}
